<div class="html-previewer-root">
  <iframe
    #previewFrame
    class="html-previewer-frame"
    title="Artifact HTML preview"
    sandbox="allow-scripts allow-same-origin allow-forms allow-modals allow-popups allow-downloads"
    referrerpolicy="no-referrer"
  ></iframe>
</div>
